import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import React from 'react';
import { TrackingServiceContext } from './TrackingServiceContext';

export const TrackingServiceContextProvider: React.FC<{
  trackingService: TrackingServiceV2;
  children?: React.ReactNode;
}> = ({ trackingService, children }) => {
  return (
    <TrackingServiceContext.Provider value={{ trackingService }}>
      {children}
    </TrackingServiceContext.Provider>
  );
};

TrackingServiceContextProvider.displayName = 'TrackingServiceContextProvider';
